/* v9: B2B price only on orders of 50+ pcs (matches the HIQB2B40 minimum quantity) */
(function () {
  function init() {
    var roots = document.querySelectorAll('[data-b2b]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.minReady) return; root.dataset.minReady = '1';
      var min = parseInt(root.getAttribute('data-b2b-min-order') || root.getAttribute('data-b2b-token-qty'), 10) || 50;
      var tok = parseInt(root.getAttribute('data-b2b-token-amount'), 10) || 2000;
      var tokTxt = tok.toLocaleString('en-IN');
      function pcs() {
        var n = 0;
        Array.prototype.forEach.call(root.querySelectorAll('[data-b2b-input]'), function (i) { n += Math.max(0, parseInt(i.value, 10) || 0); });
        return n;
      }
      function apply() {
        var n = pcs(), short = n > 0 && n < min;
        var checkout = root.querySelector('[data-b2b-checkout]');
        var barTok = root.querySelector('[data-b2b-bar-tok]');
        var meterText = root.querySelector('[data-b2b-meter-text]');
        if (checkout && n < min) checkout.disabled = true;
        var msg = 'Add ' + (min - n) + ' more pcs to unlock the B2B price + ' + tokTxt + ' IQ Tokens (min. ' + min + ' pcs per order)';
        if (n === 0) msg = 'B2B price applies on orders of ' + min + '+ pcs. Add ' + min + ' pcs to unlock it + ' + tokTxt + ' IQ Tokens';
        if (n < min) {
          if (barTok) { barTok.textContent = short ? msg : barTok.textContent; barTok.classList.toggle('is-warn', short); }
          if (meterText) meterText.textContent = msg;
        } else if (barTok) barTok.classList.remove('is-warn');
        /* savings calculator */
        var q = root.querySelector('[data-calc-qty]');
        if (q) {
          var qv = parseInt(q.value, 10) || 0;
          var b2b = root.querySelector('[data-calc-b2b]'), save = root.querySelector('[data-calc-save]'), retail = root.querySelector('[data-calc-retail]'), ct = root.querySelector('[data-calc-tok]');
          if (qv < min) {
            if (b2b && retail) b2b.textContent = retail.textContent;
            if (save) save.textContent = '₹0';
            if (ct) ct.textContent = 'Add ' + (min - qv) + ' more pcs for B2B price';
          }
        }
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-b2b-checkout]');
        if (b && pcs() < min) { e.preventDefault(); e.stopImmediatePropagation(); apply(); }
      }, true);
      ['click', 'input', 'change'].forEach(function (t) { root.addEventListener(t, function () { setTimeout(apply, 0); }); });
      setTimeout(apply, 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else setTimeout(init, 0);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
